<template>
  <div class="wrapp-customer-result">
    <template>
      <div class="wrapp-totals">
        <span class="text">{{$t('totals')}}:  {{totalCount}}</span>
      </div>
      <div class="wrapp-customers">
        <div class="wrapp-customers-wrapp">
          <ul class="wrapp-customers-wrapp-list">
            <li v-for="customer in customers" :key="customer.id" class="wrapp-customers-wrapp-list-item">
              <customerTile :customer="customer" :inputText="inputText" />
            </li>
            <li v-show="!customers.length">
              <div class="no-customers text-center mt-4">
                {{ $t('search.no-user-found') }}
              </div>
            </li>
          </ul>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import CustomerTile from 'theme/components/Search/Tiles/CustomerTile'

export default {
  name: 'Customers',
  props: {
    searchResponse: {
      type: Array | Object,
      required: true
    },
    inputText: {
      type: String,
      default: () => ''
    }
  },
  computed: {
    customers () {
      if (this.searchResponse) {
        return this.searchResponse.items
      } else {
        return []
      }
    },
    totalCount () {
      if (this.searchResponse) {
        return this.searchResponse.total_count || 0
      } else {
        return 0
      }
    }
  },
  components: {
    CustomerTile
  }
}
</script>
